import axios from "axios";
import consts from "../consts";
import { setErroAPI } from "../common/toast/toast";

export function setModoTela(modo, registro = {}) {
    return {
        type: "MONITORAMENTO_CONSUMO_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setAguardando(aguardando) {
    return {
        type: "MONITORAMENTO_CONSUMO_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function setFiltro(filtro) {
    return {
        type: "MONITORAMENTO_CONSUMO_FILTRO",
        payload: filtro,
    };
}
export function setDataInicialGrafico(data) {
    return {
        type: "MONITORAMENTO_CONSUMO_SET_DATA_INICIAL_GRAFICO",
        payload: data,
    };
}

export function setDataFinalGrafico(data) {
    return {
        type: "MONITORAMENTO_CONSUMO_SET_DATA_FINAL_GRAFICO",
        payload: data,
    };
}

export async function getMonitoramentoConsumo() {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        const aguardando = getState().monitoramentoConsumo.aguardando;
        if (aguardando || !usuarioLogado) return {};
        try {
            dispatch(setAguardando(true));
            dispatch({
                type: "MONITORAMENTO_CONSUMO_LISTADO",
                payload: { data: [] },
            });

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const filtro = getState().monitoramentoConsumo.filtro;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : filtro.id_cliente;
            const tipoContratoDemanda = filtro.id_tipo_contrato_demanda || 0;

            const resposta = await axios.get(
                `${consts.API_URL}/consumoLeitura?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&id_tipo_contrato_demanda=${tipoContratoDemanda}&id_empresa=${idEmpresa}`
            );

            const listaConsumoLeitura = (resposta.data || [])
                .filter((item) => !filtro.unidades_consumidoras.length || filtro.unidades_consumidoras.find((uc) => uc.value == item.id_unidade_consumidora))
                .map((item) => {
                    //DEFINIR COR DE ATINGIDA E ULTRAPASSAGEM
                    //inclui 4 atributos com cores indefinidas
                    item.consumoLeitura.cor_maior_demanda_mes = null;
                    item.consumoLeitura.cor_demanda_ponta = null;
                    item.consumoLeitura.cor_demanda_fora_ponta = null;
                    item.consumoLeitura.cor_demanda_reservado = null;

                    item.consumoLeitura.cor_demanda_geracao = null;

                    //----------------------------------------------------------------------------------------------------------------------------------
                    const horosazonalVerde = item.id_modalidade_tarifaria == 1;
                    const horosazonalAzul = item.id_modalidade_tarifaria == 2;

                    //HOROSAZONAL VERDE pega o maior dos 3 e compara com o fora ponta
                    if (horosazonalVerde) {
                        item.consumoLeitura.cor_maior_demanda_mes = calcularCorDemanda(item.consumoLeitura.maior_demanda_mes, item.demanda_fora_ponta_contratada_mes_atual);
                        const valores = [
                            parseFloat(item.consumoLeitura.demanda_ponta),
                            parseFloat(item.consumoLeitura.demanda_fora_ponta),
                            parseFloat(item.consumoLeitura.demanda_reservado),
                        ];
                        const maior = Math.max(...valores);
                        const indiceMaior = valores.indexOf(maior);
                        switch (indiceMaior) {
                            case 0:
                                item.consumoLeitura.cor_demanda_ponta = calcularCorDemanda(item.consumoLeitura.demanda_ponta, item.demanda_ponta_contratada_mes_atual);
                                break;
                            case 1:
                                item.consumoLeitura.cor_demanda_fora_ponta = calcularCorDemanda(
                                    item.consumoLeitura.demanda_fora_ponta,
                                    item.demanda_fora_ponta_contratada_mes_atual
                                );
                                break;
                            case 2:
                                item.consumoLeitura.cor_demanda_reservado = calcularCorDemanda(item.consumoLeitura.demanda_reservado, item.demanda_reservado_contratada_mes_atual);
                                break;
                            default:
                                break;
                        }
                    }

                    //HOROSAZONAL AZUL compara ponta com ponta e fora ponta com fora ponta
                    if (horosazonalAzul) {
                        item.consumoLeitura.cor_demanda_ponta = calcularCorDemanda(item.consumoLeitura.demanda_ponta, item.demanda_ponta_contratada_mes_atual);
                        item.consumoLeitura.cor_demanda_fora_ponta = calcularCorDemanda(item.consumoLeitura.demanda_fora_ponta, item.demanda_fora_ponta_contratada_mes_atual);
                    }

                    //geração é independente de fp, p e reserv;
                    item.consumoLeitura.cor_demanda_geracao = calcularCorDemanda(item.consumoLeitura.demanda_geracao, item.demanda_geracao_contratada_mes_atual);

                    return item;
                });

            dispatch({
                type: "MONITORAMENTO_CONSUMO_LISTADO",
                payload: { data: listaConsumoLeitura },
            });

            //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export async function getDemanda({ id_unidade_consumidora }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "MONITORAMENTO_CONSUMO_DEMANDA_LISTADO",
                payload: null,
            });

            const state = getState().monitoramentoConsumo;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const resp = await axios.get(
                `${consts.API_URL}/demandaContrato?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&id_tipo_contrato_demanda=${state.filtro.id_tipo_contrato_demanda}&ids_unidades_consumidoras=${id_unidade_consumidora}&encerrado=false`
            );
            const demandas = resp.data || [];
            //só seta a vigente quando seleciona uma única UC no filtro
            const vigente = resp.data.find((demanda) => demanda.id_unidade_consumidora == id_unidade_consumidora) || null;
            dispatch({
                type: "MONITORAMENTO_CONSUMO_DEMANDA_LISTADO",
                payload: {
                    demandas,
                    vigente,
                },
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getDemandaContagem({ id_cliente, id_unidade_consumidora }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "MONITORAMENTO_CONSUMO_DEMANDA_CONTAGEM_LISTADO",
                payload: { data: [] },
            });

            dispatch({
                type: "MONITORAMENTO_CONSUMO_AGENDAMENTO_DEMANDA",
                payload: { data: [] },
            });

            const state = getState().monitoramentoConsumo;
            const idTipoContratoDemanda = state.filtro.id_tipo_contrato_demanda || 0;

            const resp = await axios.get(
                `${consts.API_URL}/demandaContrato/listarContagemComAgendamentoDemanda?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${id_cliente}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
            );

            const demanda = resp.data.find((demanda) => demanda.id_unidade_consumidora == id_unidade_consumidora) || {};
            const listaAgendamentoDemanda = await getListaAgendamento(demanda.id, idTipoContratoDemanda);
            listaAgendamentoDemanda.forEach((agendamento, indice, lista) => {
                const ano = String(agendamento.competencia_inicio_vigencia).substring(0, 4);
                const mes = String(agendamento.competencia_inicio_vigencia).substring(4, 6);

                const agendamentoOrdenado = {};

                //ordernar conforme mes de inicio, para que inicie em janeiro na tabela
                for (let i = demanda.mes_inicio, j = 1; j <= 12; j++, i++) {
                    if (i > 12) {
                        i = 1;
                    }
                    agendamentoOrdenado[`valor_${i}`] = agendamento[`valor_${j}`];
                }
                agendamentoOrdenado.id_demanda_contrato = demanda.id;
                agendamentoOrdenado.competencia_inicio_vigencia = agendamento.competencia_inicio_vigencia;
                agendamentoOrdenado.competencia_formatada = `Agendado ${mes}/${ano}`;
                agendamentoOrdenado.mensagem_tooltip = `Início previsto para ${mes}/${ano}`;

                lista[indice] = { ...agendamentoOrdenado };
            });
            listaAgendamentoDemanda.sort((a, b) => a.competencia_inicio_vigencia - b.competencia_inicio_vigencia);

            dispatch({
                type: "MONITORAMENTO_CONSUMO_AGENDAMENTO_DEMANDA",
                payload: { data: listaAgendamentoDemanda },
            });

            dispatch({
                type: "MONITORAMENTO_CONSUMO_DEMANDA_CONTAGEM_LISTADO",
                payload: resp,
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

async function getListaAgendamento(idDemanda, idTipoContratoDemanda) {
    try {
        const agendamentos = await axios.get(
            `${consts.API_URL}/demandaAgendamento?id_demanda_contrato=${idDemanda || 0}&id_tipo_contrato_demanda=${idTipoContratoDemanda}&executado=false`
        );
        return agendamentos.data || [];
    } catch (erro) {
        setErroAPI(erro);
        return [];
    }
}

function calcularCorDemanda(valorLido, demandaContratada) {
    if (isNaN(parseFloat(valorLido))) return null;
    return parseFloat(valorLido) > parseFloat(demandaContratada) * 1.05 ? "#ff3164" : parseFloat(valorLido) >= parseFloat(demandaContratada) ? "#15b85b" : null;
}

//listas usadas nos filtros
export function carregarListas() {
    return (dispatch, getState) => {
        dispatch([getListaCliente(), getListaUnidadeConsumidora(), getListaDemandaContratoTipo()]);
    };
}

export function getRede({ idCliente, idUc, callback }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            dispatch(setAguardando(true));
            const resp = await axios.get(
                `${consts.API_URL}/rede?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&id_unidade_consumidora=${idUc}&id_empresa=${idEmpresa}`
            );
            if (callback) {
                callback(resp.data && resp.data[0] ? resp.data[0] : null);
            }
        } catch (e) {
            setErroAPI(e);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/cliente/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "MONITORAMENTO_CONSUMO_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "MONITORAMENTO_CONSUMO_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaDemandaContratoTipo() {
    const request = axios.get(`${consts.API_URL}/demandaContratoTipo/listarselect`);
    return {
        type: "MONITORAMENTO_CONSUMO_CONTRATO_DEMANDA_TIPO_SELECT_LISTADO",
        payload: request,
    };
}

//usado para atualizar a lista quando edita o valor
export async function atualizarListaGraficoDemanda(payload) {
    return async (dispatch, getState) => {
        dispatch({
            type: "MONITORAMENTO_CONSUMO_DEMANDA_CONTRATADA_LISTADO",
            payload: payload.data ? payload : { data: payload },
        });
    };
}

// GRÁFICOS
export async function getListaGraficoDemanda({ id_cliente, id_unidade_consumidora, contrato_demanda_sazonal }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch(atualizarListaGraficoDemanda([]));
            dispatch({
                type: "MONITORAMENTO_CONSUMO_GRAFICO_DEMANDA_INDICE_SAZONALIDADE_LISTADO",
                payload: { data: [] },
            });
            const state = getState().monitoramentoConsumo;
            let respostaListaGrafico = { data: [] };
            let respostaIdicesSazonalidade = { data: [] };

            const idTipoContratoDemanda = state.filtro.id_tipo_contrato_demanda || 0;

            //sazonal e não sazonal apenas quando tiver uma Única UC
            //SE FOR UMA UC APENAS, TRAZ DADOS SAZONAL OU NÂO SAZONAL, DE ACORDO COM A UC
            if (contrato_demanda_sazonal) {
                respostaIdicesSazonalidade = await axios.get(
                    `${consts.API_URL}/fatura/listarSazonalidadeAnualPorUcSazonal?id_usuario_logado=${usuarioLogado.id}&id_cliente=${id_cliente}&id_unidade_consumidora=${id_unidade_consumidora}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
                );

                //busca enpoint sazonal *fazer rota
                respostaListaGrafico = await axios.get(
                    `${consts.API_URL}/fatura/listarGraficoDemandaSazonal?id_usuario_logado=${usuarioLogado.id}&id_cliente=${id_cliente}&id_unidade_consumidora=${id_unidade_consumidora}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
                );
            } else {
                respostaIdicesSazonalidade = await axios.get(
                    `${consts.API_URL}/fatura/listarSazonalidadeAnualPorUcNaoSazonal?id_usuario_logado=${usuarioLogado.id}&id_cliente=${id_cliente}&id_unidade_consumidora=${id_unidade_consumidora}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
                );

                //busca enpoint nao sazonal *fazer rota
                respostaListaGrafico = await axios.get(
                    `${consts.API_URL}/fatura/listarGraficoDemandaNaoSazonal?id_usuario_logado=${usuarioLogado.id}&id_cliente=${id_cliente}&id_unidade_consumidora=${id_unidade_consumidora}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
                );
            }
            dispatch({
                type: "MONITORAMENTO_CONSUMO_GRAFICO_DEMANDA_INDICE_SAZONALIDADE_LISTADO",
                payload: respostaIdicesSazonalidade,
            });
            dispatch(atualizarListaGraficoDemanda(respostaListaGrafico));
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export function getListaGraficoTodasIntegracoesAgrupadasPorHora() {
    return (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            const aguardando = getState().monitoramentoConsumo.aguardando;
            if (aguardando || !usuarioLogado) return {};
            const data = getState().consumoLeitura.dataGrafico;
            const { id_cliente, id_unidade_consumidora, intervalo_tempo } = getState().consumoLeitura.filtro;
            const resposta = axios.get(
                `${consts.API_URL}/consumoLeitura/listaGraficoTodasIntegracoesAgrupadasPorIntervaloTempo?data=${data}&id_cliente=${id_cliente}&id_unidade_consumidora=${id_unidade_consumidora}&intervalo_tempo=${intervalo_tempo}`
            );
            dispatch({
                type: "MONITORAMENTO_CONSUMO_LISTA_GRAFICO_TODAS_INTEGRACOES_AGRUPADAS_POR_HORA",
                payload: resposta,
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function ouvirBroker() {
    return (dispatch, getState) => {
        dispatch({ type: "MONITORAMENTO_CONSUMO_RESET_DADOS_BROKER" });
        const { usuarioLogado, usuario } = getState().auth;
        if (!usuarioLogado || !usuario) return null;

        const eventSource = new EventSource(`${consts.API_URL}/consumoLeitura/broker?token=${usuario.token}`);

        eventSource.onmessage = (event) => {
            const data = JSON.parse(event.data);

            dispatch({
                type: "MONITORAMENTO_CONSUMO_DADOS_BROKER",
                payload: data,
            });
        };

        eventSource.onerror = (error) => {
            console.error("Erro na conexão SSE:", error);
            eventSource.close();
        };

        return eventSource; // 🔥 AGORA SIM
    };
}

export async function getListaGraficoDia({ id_consumo_integracao, dataInicial, dataFinal }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            const aguardando = getState().monitoramentoConsumo.aguardando;
            if (aguardando || !usuarioLogado) return {};

            dispatch(setAguardando(true));

            const resposta = axios.get(
                `${consts.API_URL}/consumoLeitura/listaGraficoDia?id_usuario_logado=${usuarioLogado.id}&id_consumo_integracao=${
                    id_consumo_integracao || null
                }&data_inicial=${dataInicial}&data_final=${dataFinal}`
            );
            dispatch({
                type: "MONITORAMENTO_CONSUMO_LISTA_GRAFICO_DIA",
                payload: resposta,
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getListaGraficoDiasMes({ id_consumo_integracao, dataInicial, dataFinal, tipoInformacao }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            dispatch(setAguardando(true));
            const resposta = axios.get(
                `${consts.API_URL}/consumoLeitura/listaGraficoDiasMes?id_usuario_logado=${usuarioLogado.id}&id_consumo_integracao=${id_consumo_integracao || null}&data_inicial=${dataInicial}&data_final=${dataFinal}&tipo_informacao=${tipoInformacao || "energia"}`
            );
            dispatch({ type: "MONITORAMENTO_CONSUMO_LISTA_GRAFICO_DIAS_MES", payload: resposta });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getListaGraficoMesesAno({ id_consumo_integracao, dataInicial, dataFinal, tipoInformacao }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            dispatch(setAguardando(true));
            const resposta = axios.get(
                `${consts.API_URL}/consumoLeitura/listaGraficoMesesAno?id_usuario_logado=${usuarioLogado.id}&id_consumo_integracao=${id_consumo_integracao || null}&data_inicial=${dataInicial}&data_final=${dataFinal}&tipo_informacao=${tipoInformacao || "energia"}`
            );
            dispatch({ type: "MONITORAMENTO_CONSUMO_LISTA_GRAFICO_MESES_ANO", payload: resposta });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export async function setStatusVisualizado({ id, coluna }) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            await axios.patch(`${consts.API_URL}/consumoLeitura/setStatusVisualizado`, { id, coluna });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
